import MenuSection from "../components/MenuSection";
import React, { useState, useEffect } from "react";
import { Autocomplete } from "@mui/material";
import {
  Box,
  TextField,
  CircularProgress,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  Modal,
  Checkbox,
  ListItemText,
  Select,
  OutlinedInput,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import empleados from "../api/empleados";
import cierreAnterior from "../api/cierreAnterior";
import { useNavigate } from "react-router-dom";
import cierreDeTurno from "../api/cierreDeTurno";
import puedeCerrarTurno from "../api/puedeCerrarTurno";
import apiErrorHandler from "../helpers/apiErrorHandler"; // Importa el helper
import GrupoMangueras from "../api/getGrupoMangueras";

const CierreTurnoPage = () => {
  const [modalWidth, setModalWidth] = useState(window.innerWidth < 700 ? "360px" : "100%");
  const esDUO = JSON.parse(localStorage.getItem("esDUO")) || false;
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const puesto = localStorage.getItem("puesto");
  const puestoObj = JSON.parse(puesto);
  const idGrupoManguerasAForzar = puestoObj?.idGrupoManguerasAForzar;
  const nombre = puestoObj.caja?.descripcion ? puestoObj.caja.descripcion : puestoObj.nombre;
  const [empleadosActivos, setEmpleadosActivos] = useState([]);
  const [cierreAnteriorValue, setCierreAnteriorValue] = useState("");
  const [empleadoInputs, setEmpleadoInputs] = useState([]);
  const idCaja = puestoObj.caja.idCaja;
  const [cierreActual, setCierreActual] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const navigate = useNavigate();
  const [selectedPlayero, setSelectedPlayero] = useState("");
  const [selectedEncargado, setSelectedEncargado] = useState("");
  const [selectedPlayeros, setSelectedPlayeros] = useState([]);
  const [descripcion, setDescripcion] = useState("");
  const [dialogo, setDialogo] = useState("");
  const [playeroError, setPlayeroError] = useState(false);
  var cantidadPlayerosSolicitados = localStorage.getItem("cantidadPlayerosSolicitados");
  cantidadPlayerosSolicitados = cantidadPlayerosSolicitados - 1;
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [openModalAsignarGrupos, setOpenModalAsignarGrupos] = useState(false);
  const [gruposMangueras, setGruposMangueras] = useState([]);
  const [asignacionPlayerosPorGrupo, setAsignacionPlayerosPorGrupo] = useState({});
  const [isLoadingGrupos, setIsLoadingGrupos] = useState(false);
  const [cierreCompartido, setCierreCompartido] = useState(false);
  const [openSelects, setOpenSelects] = useState({});

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
    navigate("/home");
  };

  const handleCancel = () => {
    setOpenConfirmDialog(false);
  };

  const puedeCerrar = async () => {
    try {
      const puedeCerrarTurnoActual = await puedeCerrarTurno.getPuedeCerrarTurno(idCaja, cierreCompartido);
      console.log(puedeCerrarTurnoActual);
      setDialogo(puedeCerrarTurnoActual);
      setOpenConfirmDialog(true);
    } catch (error) {
      console.log(error);
      apiErrorHandler(error, { stopFlow: true });
    }
  };

  const handleConfirm = async () => {
    console.log(selectedEncargado);
    setOpenConfirmDialog(false);

    const filledPlayeros = [...selectedPlayeros];
    while (filledPlayeros.length < 8) {
      filledPlayeros.push(null);
    }

    // Construir PlayerosPorGrupoMangueras solo si corresponde
    let cierreTurno = {
      IdCaja: idCaja,
      IdPuesto: puestoObj.idPuesto,
      Descripcion: dialogo,
      Encargado: selectedEncargado
        ? {
            IdEncargado: selectedEncargado.idEmpleado,
            Descripcion: selectedEncargado.nombreEmpleado,
          }
        : null,
      Playeros: filledPlayeros.map(playero =>
        playero
          ? {
              IdPlayero: playero.idEmpleado,
              Descripcion: playero.nombreEmpleado,
            }
          : null,
      ),
    };

    if (idGrupoManguerasAForzar != null) {
      const playerosPorGrupoMangueras = {};
      Object.entries(asignacionPlayerosPorGrupo).forEach(([grupoId, playeros]) => {
        playerosPorGrupoMangueras[grupoId] = playeros.map(p => p.idEmpleado);
      });
      cierreTurno = {
        ...cierreTurno,
        PlayerosPorGrupoMangueras: playerosPorGrupoMangueras,
      };
    }

    setIsLoading(true);

    try {
      const cierreTurnoJSON = JSON.stringify(cierreTurno);
      const response = await cierreDeTurno.postCierreDeTurno(cierreTurnoJSON);
      console.log(localStorage.getItem("errorMensajeCierreTurno"));
      const errorCierreTurno = localStorage.getItem("errorMensajeCierreTurno");
      if (errorCierreTurno) {
        setDialogTitle("No se pudo cerrar el turno");
        setDialogMessage(errorCierreTurno);
      } else {
        setDialogTitle("Cierre de turno");
        setDialogMessage(response);

        // Guardar la fecha y hora del cierre actual como el nuevo cierre anterior
        const now = new Date();
        now.setHours(now.getHours());
        const fecha = now.toLocaleDateString("es-AR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const hora = now.toLocaleTimeString("es-AR", {
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });

        localStorage.setItem(`cierreAnterior_${idCaja}`, JSON.stringify({ fecha, hora }));
      }
    } catch (error) {
      apiErrorHandler(error, { stopFlow: true });
    }

    setIsLoading(false);
    setOpenSuccessDialog(true);
  };

  const handleOpenModalAsignarGrupos = async () => {
    setIsLoadingGrupos(true);
    setOpenModalAsignarGrupos(true);
    try {
      const grupos = await GrupoMangueras.getGrupo();
      setGruposMangueras(grupos);
      // Inicializar asignación si está vacía
      if (Object.keys(asignacionPlayerosPorGrupo).length === 0) {
        const inicial = {};
        grupos.forEach(g => {
          inicial[g.idGrupoMangueras] = [];
        });
        setAsignacionPlayerosPorGrupo(inicial);
      }
    } catch (error) {
      apiErrorHandler(error, { stopFlow: true });
    }
    setIsLoadingGrupos(false);
  };

  const handleCloseModalAsignarGrupos = () => {
    setOpenModalAsignarGrupos(false);
  };

  const handleAsignarPlayerosGrupo = (idGrupo, nuevosPlayeros) => {
    setAsignacionPlayerosPorGrupo(prev => ({
      ...prev,
      [idGrupo]: nuevosPlayeros,
    }));
  };

  useEffect(() => {
    setIsLoading(true);
    const fetchEmpleadosActivos = async () => {
      try {
        const empleadosAux = await empleados.getEmpleadosActivos();
        const empleadosOrdenados = empleadosAux.sort((a, b) => a.nombreEmpleado.localeCompare(b.nombreEmpleado));
        setEmpleadosActivos(empleadosOrdenados);

        console.log(empleadosAux);
      } catch (error) {
        console.error(error);
        apiErrorHandler(error, { stopFlow: true });
      }
      setIsLoading(false);
    };

    fetchEmpleadosActivos();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      now.setHours(now.getHours() - 3); // Ajuste manual para UTC-3
      const formattedDateTime = now.toISOString().slice(0, 19); // Incluye segundos en el formato correcto para datetime-local
      setCierreActual(formattedDateTime);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchCierreAnterior = async () => {
      console.log("fetchCierreAnterior");
      try {
        const cierre = await cierreAnterior.getCierreAnterior(idCaja);
        console.log(cierre);

        // Convertir fecha y hora al formato datetime-local
        const [day, month, year] = cierre.fecha.split("/");
        const datetime = `${year}-${month}-${day}T${cierre.hora}`;
        setCierreAnteriorValue(datetime);
      } catch (error) {
        console.error(error);
        apiErrorHandler(error, { stopFlow: true });
      }
    };

    fetchCierreAnterior();
  }, [idCaja]);

  useEffect(() => {
    console.log(cantidadPlayerosSolicitados);
    const inputs = [];
    for (let index = 0; index < cantidadPlayerosSolicitados; index++) {
      inputs.push("");
    }
    setEmpleadoInputs(inputs);
  }, []);

  const handleAddEmpleado = () => {
    setEmpleadoInputs([...empleadoInputs, ""]);
    console.log(empleadoInputs);
  };

  const textFieldStyles = {
    mb: 1.5,
    "& .MuiInputBase-root": {
      height: "40px",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.85rem",
      color: "gray",
    },
  };

  // Verifica que todos los empleados seleccionados estén en al menos un grupo
  const todosEnGrupo = () => {
    const empleadosSeleccionados = [...selectedPlayeros, ...(selectedEncargado ? [selectedEncargado] : [])].filter(Boolean);

    // Junta todos los empleados asignados a cualquier grupo
    const empleadosEnGrupos = Object.values(asignacionPlayerosPorGrupo)
      .flat()
      .map(e => e.idEmpleado);

    // Todos los empleados seleccionados deben estar en al menos un grupo
    return empleadosSeleccionados.every(emp => empleadosEnGrupos.includes(emp.idEmpleado));
  };

  return (
    <>
      <MenuSection />

      <Box
        sx={{
          position: "absolute",
          width: modalWidth,
          top: window.innerWidth < 700 ? "50%" : esDUO? "60%" : "54%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          p: 4,
          borderRadius: "8px",
          height: window.innerWidth < 700 ? "80vh" : "90%",
          overflowY: "auto",
        }}
      >
        <Box sx={{ width: window.innerWidth < 700 ? "100%" : esDUO? "70%" : "50%", marginLeft: window.innerWidth < 700 ? "0%" : esDUO? "15%" : "25%" }}>
          <TextField label="CAJA" variant="outlined" fullWidth value={nombre} disabled sx={{mb: 2.2}}/>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "8rem",
                height: window.innerWidth < 700 ? 360 : 290,
              }}
            >
              <CircularProgress sx={{ color: theme.bandera.colorSecundario }} />
            </div>
          ) : (
            <>
              <Grid container spacing={esDUO? 2 : 0.5}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={empleadosActivos}
                    getOptionLabel={option => option.nombreEmpleado}
                    onChange={(event, newValue) => {
                      setSelectedEncargado(newValue);
                    }}
                    renderInput={params => <TextField {...params} label="Encargado" variant="outlined" />}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={empleadosActivos}
                    getOptionLabel={option => option.nombreEmpleado}
                    onChange={(event, newValue) => {
                      setSelectedPlayero(newValue?.nombreEmpleado || "");
                      setPlayeroError(false);
                      setSelectedPlayeros(prev => [...prev, newValue]);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Playero"
                        variant="outlined"
                        error={playeroError}
                        helperText={playeroError ? "Por favor, seleccione un Playero" : ""}
                      />
                    )}
                  />
                </Grid>

                {empleadoInputs.map((input, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <TextField
                      label={`Playero ${index + 2}`}
                      select
                      variant="outlined"
                      fullWidth
                      sx={textFieldStyles}
                      value={selectedPlayeros[index + 1] ? selectedPlayeros[index + 1].nombreEmpleado : ""}
                      onChange={e => {
                        const playero = empleadosActivos.find(emp => emp.nombreEmpleado === e.target.value);
                        const newSelectedPlayeros = [...selectedPlayeros];
                        newSelectedPlayeros[index + 1] = playero;
                        setSelectedPlayeros(newSelectedPlayeros);
                      }}
                      error={playeroError}
                      helperText={playeroError ? "Por favor, seleccione un Playero" : ""} // Mostrar mensaje de error
                    >
                      {empleadosActivos.map(option => (
                        <MenuItem key={option.nombreEmpleado} value={option.nombreEmpleado}>
                          {option.nombreEmpleado}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <TextField
                    label="Cierre anterior"
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    value={cierreAnteriorValue}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Cierre actual"
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    value={cierreActual}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start", // Alinea el contenido a la izquierda
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <Button
                  startIcon={<AddIcon />}
                  sx={{
                    fontWeight: "bold",
                    fontSize: 17,
                  }}
                  onClick={handleAddEmpleado}
                >
                  Agregar Empleado
                </Button>
              </Box>
              {idGrupoManguerasAForzar != null && selectedPlayero && (
                <>
                  <Button
                    sx={{
                      fontWeight: "bold",
                      fontSize: 14,
                      my: 2,
                    }}
                    onClick={handleOpenModalAsignarGrupos}
                  >
                    Asignar playeros a grupos de mangueras
                  </Button>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Checkbox checked={cierreCompartido} onChange={e => setCierreCompartido(e.target.checked)} />
                    <Typography>Próximo cierre en modo "Compartido"</Typography>
                  </Box>
                </>
              )}
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end", // Alinea el contenido a la derecha
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      boxShadow: 0,
                      fontWeight: "bold",
                      fontSize: 17,
                      marginTop: "10px",
                      backgroundColor: theme.bandera.colorSecundario,
                      ":hover": {
                        backgroundColor: theme.bandera.colorSecundario,
                      },
                    }}
                    onClick={() => {
                      if (!selectedPlayero) {
                        setPlayeroError(true);
                        return;
                      }
                      puedeCerrar();
                    }}
                    disabled={idGrupoManguerasAForzar != null && !todosEnGrupo()}
                  >
                    CERRAR TURNO
                  </Button>
                </Box>
              </>
            </>
          )}
        </Box>
      </Box>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: theme.palette.background.default,
            boxShadow: theme.shadows[5],
            borderRadius: theme.shape.borderRadius,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Cierre de turno"}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: "1rem" }}>{dialogo}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "bold" }}>
              Cancelar
            </Typography>
          </Button>

          <Button onClick={handleConfirm} color="primary" autoFocus>
            <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "bold" }}>
              Aceptar
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSuccessDialog}
        onClose={handleCloseSuccessDialog}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: theme.palette.background.default,
            boxShadow: theme.shadows[5],
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle id="success-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: "1rem" }}>{dialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSuccessDialog} color="primary" autoFocus>
            <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "bold" }}>
              Aceptar
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL ASIGNACIÓN DE GRUPOS */}
      <Modal
        open={openModalAsignarGrupos}
        onClose={handleCloseModalAsignarGrupos}
        aria-labelledby="modal-asignar-grupos-title"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          mt: 7,
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            p: "17px 31px",
            width: "100%",
            maxWidth: 600,
            maxHeight: "91vh",
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              color: theme.bandera.colorSecundario,
              fontSize: 15,
              fontWeight: 600,
              mb: 4,
            }}
          >
            Asignar playeros a grupos de mangueras
          </Typography>
          <Box
            sx={{
              flex: 1,
              overflowY: "scroll",
              pr: 1,
              minHeight: 200,
              maxHeight: "calc(87vh - 120px)",
              "&::-webkit-scrollbar": {
                width: "8px",
                backgroundColor: "#e0e0e0",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#bdbdbd",
                borderRadius: "4px",
              },
              "&": {
                scrollbarColor: "#bdbdbd #e0e0e0",
                scrollbarWidth: "thin",
              },
            }}
          >
            {isLoadingGrupos ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Grid container spacing={2}>
                {gruposMangueras.map(grupo => {
                  // Calcular todos los empleados seleccionados (playeros y encargado)
                  const todosSeleccionados = [...selectedPlayeros, ...(selectedEncargado ? [selectedEncargado] : [])].filter(Boolean);

                  // Permitir que los empleados estén en varios grupos: todos los seleccionados están disponibles
                  const empleadosDisponibles = todosSeleccionados;

                  return (
                    <Grid item xs={12} key={grupo.idGrupoMangueras}>
                      <Typography sx={{ fontWeight: "bold", color: theme.bandera.colorSecundario, mb: 2, fontSize: 15 }}>{grupo.nombre}</Typography>
                      <Select
                        multiple
                        fullWidth
                        value={asignacionPlayerosPorGrupo[grupo.idGrupoMangueras] || []}
                        open={!!openSelects[grupo.idGrupoMangueras]}
                        onOpen={() => setOpenSelects({ ...openSelects, [grupo.idGrupoMangueras]: true })}
                        onClose={() => setOpenSelects({ ...openSelects, [grupo.idGrupoMangueras]: false })}
                        onChange={e => handleAsignarPlayerosGrupo(grupo.idGrupoMangueras, e.target.value)}
                        input={<OutlinedInput label="Playeros" />}
                        renderValue={selected => selected.map(p => p.nombreEmpleado).join(", ")}
                      >
                        {empleadosDisponibles.map(empleado => (
                          <MenuItem key={empleado.idEmpleado} value={empleado}>
                            <Checkbox checked={(asignacionPlayerosPorGrupo[grupo.idGrupoMangueras] || []).some(e => e.idEmpleado === empleado.idEmpleado)} />
                            <ListItemText primary={empleado.nombreEmpleado} />
                          </MenuItem>
                        ))}
                        <MenuItem disableRipple disableTouchRipple style={{ justifyContent: "center" }}>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={e => {
                              e.stopPropagation();
                              setOpenSelects({ ...openSelects, [grupo.idGrupoMangueras]: false });
                            }}
                            sx={{ width: "100%" }}
                          >
                            Cerrar
                          </Button>
                        </MenuItem>
                      </Select>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 3,
              bgcolor: "background.paper",
              pt: 2,
              position: "sticky",
              bottom: 0,
              zIndex: 2,
            }}
          >
            <Button
              onClick={handleCloseModalAsignarGrupos}
              sx={{
                boxShadow: 0,
                fontWeight: "bold",
                fontSize: 17,
                mr: 2,
                marginTop: "10px",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              variant="contained"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleCloseModalAsignarGrupos}
              sx={{
                boxShadow: 0,
                fontWeight: "bold",
                fontSize: 17,
                marginTop: "10px",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              variant="contained"
              disabled={!todosEnGrupo()}
            >
              Aceptar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CierreTurnoPage;
